export default __webpack_public_path__ + "static/media/hammer.7d6a42b6.svg";